import { ILocalizationDictionary, ITranslation } from './interfaces';

export class Translation {
	public static processTranslationsList(data: ILocalizationDictionary[]):
		{ list: ITranslation[], map: Record<number, Record<string, string>> } {

		let list: ITranslation[];
		let entries: ILocalizationDictionary[];

		list = new Array();
		entries = data;

		for (let entry of entries) {

			let newKeyword = true;

			for (let keyword of list) {
				if (entry.Keyword === keyword.keyword) {
					newKeyword = false;

					keyword.translations[entry.LanguageCode] = {
						Keyword: entry.Keyword,
						Id: entry.Id,
						LanguageCode: entry.LanguageCode,
						Word: entry.Word
					}
					break;
				}
			}
			if (newKeyword) {
				list.push({
					keyword: entry.Keyword,
					translations: {}
				});

				for (let keyword of list) {
					if (entry.Keyword === keyword.keyword) {
						keyword.translations[entry.LanguageCode] = {
							Keyword: entry.Keyword,
							Id: entry.Id,
							LanguageCode: entry.LanguageCode,
							Word: entry.Word
						}
						break;
					}
				}
			}
		};

		return {
			list: list,
			map: Translation.configureMap(data)
		};
	}

	public static configureMap(translations: ILocalizationDictionary[]): Record<number, Record<string, string>> {

		let languageHashMap: Record<number, Record<string, string>> = new Array();

		if (!translations || translations.length === 0) {
			return;
		}

		for (let translation of translations) {
			if (!languageHashMap[translation.LanguageCode]) {
				languageHashMap[translation.LanguageCode] = {};
			}

			languageHashMap[translation.LanguageCode][translation.Keyword] = translation.Word;
		}

		return languageHashMap;
	}
}
